import {
  FRANCHISE,
  DIGITAL_FRANCHISE,
  MANAGE_ACTION,
  NETWORKER_MENU,
  READ_ACTION,
  DIGITAL_FRANCHISE_PURCHASE,
  FRANCHISE_MANUAL,
} from "@/constants/resources";

export default [
  {
    title: "Franquias",
    icon: "none",
    children: [
      {
        title: "Networkers",
        route: "networker-list",
        icon: "UsersIcon",
        resource: NETWORKER_MENU,
        action: READ_ACTION,
      },
      {
        title: "Escritórios",
        route: "physical-franchise-list",
        icon: "HomeIcon",
        resource: FRANCHISE,
        action: MANAGE_ACTION,
      },
      {
        title: "Franquias digitais",
        route: "franchisees-list",
        icon: "MousePointerIcon",
        resource: DIGITAL_FRANCHISE,
        action: MANAGE_ACTION,
      },
      {
        title: "Compra de franquias",
        route: "franchisees-purchase-list",
        icon: "DollarSignIcon",
        resource: DIGITAL_FRANCHISE_PURCHASE,
        action: MANAGE_ACTION,
      },
      {
        title: "Manuais do Franqueado",
        route: "franchise-manuals-list",
        icon: "BookOpenIcon",
        resource: FRANCHISE_MANUAL,
        action: READ_ACTION,
      },
    ],
  },
];
